const DevConfig = {
  AUTH_API_URL: "https://auth.um-agency.com/api",
  BASE_RCT_API_URL: "https://cms.um-agency.com/api/v1",
  BASE_API_URL: "https://cms.um-agency.com/api/v1",
  BASE_STATS_API_URL: "https://api-stat.um-agency.com/api",
  BASE_STORAGE_URL: "https://cbe8-212-174-81-44.eu.ngrok.io/storage",
  KEYCLOAK_URL:
    "https://keycloak.um-agency.com/auth/realms/uma/protocol/openid-connect/auth?response_type=code&client_id=front",
  KEYCLOAK_LOGOUT_URL:
    "https://keycloak.um-agency.com/auth/realms/uma/protocol/openid-connect/logout?",
  API_VERSION: 6,
};

const ProdConfig = {
  AUTH_API_URL: "https://auth.um-agency.com/api",
  BASE_RCT_API_URL: "https://cms.um-agency.com/api/v1",
  BASE_STATS_API_URL: "https://api-stat.um-agency.com/api",
  BASE_API_URL: "https://cms.um-agency.com/api/v1",
  BASE_STORAGE_URL: "http://storage.um-agency.com",
  KEYCLOAK_URL:
    "https://keycloak.um-agency.com/auth/realms/uma/protocol/openid-connect/auth?response_type=code&client_id=front&scope=openid+given_name+family_name+email",
  KEYCLOAK_LOGOUT_URL:
    "https://keycloak.um-agency.com/auth/realms/uma/protocol/openid-connect/logout?",
  API_VERSION: 6,
};

export const Config = process.env.NODE_ENV === "production" ? ProdConfig : DevConfig;
